// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

/* eslint-disable */
interface IParsedAliasTimezones {
  'Europe/Belfast': {"enum_constant":"Europe/Belfast"};
  'Europe/Bratislava': {"enum_constant":"Europe/Bratislava"};
  'Europe/Ljubljana': {"enum_constant":"Europe/Ljubljana"};
  'Europe/Podgorica': {"enum_constant":"Europe/Podgorica"};
  'Europe/Sarajevo': {"enum_constant":"Europe/Sarajevo"};
  'Europe/Skopje': {"enum_constant":"Europe/Skopje"};
  'Europe/Tiraspol': {"enum_constant":"Europe/Tiraspol"};
  'Europe/Vaduz': {"enum_constant":"Europe/Vaduz"};
  'Europe/Zagreb': {"enum_constant":"Europe/Zagreb"};
}

export type AliasTimezonesId = keyof IParsedAliasTimezones;
export type AliasTimezonesData = IParsedAliasTimezones[AliasTimezonesId];
const data: AliasTimezonesData[] = [{"enum_constant":"Europe/Belfast"},{"enum_constant":"Europe/Bratislava"},{"enum_constant":"Europe/Ljubljana"},{"enum_constant":"Europe/Podgorica"},{"enum_constant":"Europe/Sarajevo"},{"enum_constant":"Europe/Skopje"},{"enum_constant":"Europe/Tiraspol"},{"enum_constant":"Europe/Vaduz"},{"enum_constant":"Europe/Zagreb"}];
export default data;
